import { render, staticRenderFns } from "./UserTypePicker.vue?vue&type=template&id=19c49947"
import script from "./UserTypePicker.vue?vue&type=script&lang=js"
export * from "./UserTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports